import { TweenMax } from "gsap";
import { IObjectConfig } from "../baseConfigs/layoutConfigShema";
import GameEvents from "../const/GameEvents";
import Layout from "../utils/Layout";
import VisualUtil from "../utils/VisualUtil";
import BaseView from "./BaseView";
import Utils from "../utils/Utils";
import TextField from "./components/TextField";
import BitmapTextField from "./components/BitmapTextField";

/**
 * Abstraction for a single symbol.
 * A reel contains several of those.
 */
export default class SymbolAnimation extends BaseView {
    // TODO COPY USEFUL LOGIC FROM EXTENDED FRAMEWORK INCLUDING DRAGON BONES INTEGRATION
    public id: number;
    public positionDefinitions: Map<string, IObjectConfig>;
    public zOrder: number;
    public reelIdx: number;
    public isFinal: boolean;
    protected bg: PIXI.Sprite;

    protected frame: PIXI.Sprite;
    protected shineFilter: any;
    protected symAnim: PIXI.extras.AnimatedSprite;
    protected overlaySticker: PIXI.extras.AnimatedSprite;
    protected bounds: IObjectConfig;
    public isLocked: boolean = false;
    public isWalking: boolean = false;
    public currentAnimation: string;

    constructor() {
        super();
        // this.removeListener('removed', this.destroy, this);
    }

    create(
        symBounds: IObjectConfig,
        positionDefinitions: Map<string, IObjectConfig>
    ) {
        // const scaleRect = new PIXI.Rectangle(0, 0, Layout.scalePixels(symBounds.width), Layout.scalePixels(symBounds.height));
        this.bounds = symBounds;
        this.positionDefinitions = positionDefinitions;

        // this.symbol = this.assets.getSprite('sym_empty');
        // this.addChild(this.symbol);
        // Layout.testSetHeight(this.symbol, symBounds.height);

        // if (this.config.symbolBlur)
        // {
        //     this.symbolBlur = this.assets.getSprite('sym_empty');
        //     this.symbolBlur.anchor.set(.5, .5);
        //     this.addChild(this.symbolBlur);
        //     this.symbolBlur.alpha = 0;
        //     Layout.testSetHeight(this.symbolBlur, symBounds.height);
        // }

        const uniform = {
            position: { type: "f", value: 0 },
            intensity: { type: "f", value: 1 },
        };
        this.shineFilter = new PIXI.Filter(
            null,
            PIXI.loader.resources.shine.data,
            uniform
        );

        this.symAnim = new PIXI.extras.AnimatedSprite([
            this.assets.getTexture("sym_empty"),
        ]);
        this.symAnim.anchor.set(0.5, 0.5);
        this.addChild(this.symAnim);
        this.symAnim.visible = false;
        this.symAnim.loop = false;
        if (this.config.overlayData) {
            this.overlaySticker = new PIXI.extras.AnimatedSprite([
                this.assets.getTexture("sym_empty"),
            ]);
            this.overlaySticker.anchor.set(0.5, 0.5);
            this.addChild(this.overlaySticker);
            this.overlaySticker.visible = false;
            this.overlaySticker.loop = false;
        }

        this.symAnim.filters = [];

        if (this.config.symbolFrame) {
            this.frame = this.assets.getSprite("win_frame");
            this.frame.anchor.set(0.5, 0.5);
            this.addChild(this.frame);
            this.frame.alpha = 0;
        }
    }

    // buildBackground() {

    //     if (!this.bg && !this.config.symbolAssetsMap[this.id].background ) {
    //         return;
    //     }

    //     const textureId = this.config.symbolAssetsMap[this.id].background || "sym_empty";
    //     if (!this.bg) {

    //         this.bg = this.assets.getSprite(textureId);
    //         this.bg.anchor.set(.5, .5);
    //         this.addChildAt(this.bg, 0);
    //     } else {
    //         this.bg.texture = this.assets.getTexture(textureId);
    //     }

    //     Layout.testSetHeight(this.bg, this.bounds.height);
    //     if (this.config.symbolBlur ) {

    //         const blurtextureId = this.config.symbolAssetsMap[this.id].background_blur || "sym_empty";
    //         if (!this.bgBlur)
    //         {
    //             this.bgBlur = this.assets.getSprite(blurtextureId);
    //             this.bgBlur.anchor.set(.5, .5);
    //             this.addChildAt(this.bgBlur, this.children.indexOf(this.bg));
    //         }else {
    //             this.bgBlur.texture = this.assets.getTexture(blurtextureId);
    //         }

    //         this.bgBlur.alpha = 0;
    //         Layout.testSetHeight(this.bgBlur, this.bounds.height);
    //     }
    // }

    // setBlurLevel(level: number)
    // {
    //     const inverseLevel = Math.min(1, (2 - level * 2));

    //     if (this.bg && this.bgBlur)
    //     {
    //         this.bg.alpha = inverseLevel;
    //         this.bgBlur.alpha = level;
    //     }

    //     if (this.config.symbolBlur)
    //     {
    //         this.symbol.alpha = inverseLevel;
    //         this.symbolBlur.alpha = level;
    //     }
    // }

    setId(id: number) {
        this.id = id;
        const anchor = this.config.symAnchors[id];
    }

    showTextOverlay(
        id: number,
        content: string
        ) {
            if (!this.overlaySticker) {
                return;
            }
            let symSpriteId: number | string = this.config.symbolAssetsMap[
                id || this.id
            ].name;
            const overlayData = this.config.overlayData[symSpriteId];
            if (!overlayData) {
                return;
            }
            let isText = overlayData.fontStyle;
            let isBmp = overlayData.bitmapFont;
            let textureBounds = Utils.deepClone(
                this.positionDefinitions.get(
                    "overlay_" + symSpriteId
                )
            );
            if(!isText || !textureBounds) {
                return;
            }

            let textBound = Utils.deepClone(textureBounds);
          
                let text:TextField|BitmapTextField;
                if(isBmp) {
                    // textBound.x = this.bounds.x - textureBounds.x/2 -  textureBounds.width + this.bounds.width/2-  textureBounds.width/2;
                    textBound.x = 0;
                    textBound.y = 0;
                    text = new BitmapTextField(content, {
                        font: {
                            name: overlayData.fontStyle,
                            size: overlayData.fontSize,
                        },
                    },
                        {

                            bound: textBound,
                            anchor: {
                                x: 0,
                                y: 0
                            }
                        }
                    );
                    text.x = Layout.scalePixels(this.bounds.x + this.bounds.width / 2 - textureBounds.x - textureBounds.width / 2) - text.width/2;
                    text.y = Layout.scalePixels(this.bounds.y - textureBounds.y  -  textureBounds.height + this.bounds.height/2) ;
                } else {
                    text = new TextField(content,overlayData,{
                        bound:textBound,
                        anchor: {
                            x: 0.5,
                            y: 0
                        }
                    })

                    // text.centerVertical()
                }

                this.overlaySticker.addChild(text);
                this.overlaySticker.visible = true;

                // Layout.testSetWidth(
                //     this.overlaySticker,
                //     textureBounds.width
                // );
                // let boundX = this.bounds.x + this.bounds.width / 2;
                // let textX = textureBounds.x + textureBounds.width / 2;

                // this.overlaySticker.x = Math.ceil(
                //     Layout.scalePixels(textX - boundX)
                // );

                // this.overlaySticker.x = Math.ceil(Layout.scalePixels(this.bounds.x + this.bounds.width / 2 - textureBounds.x - textureBounds.width / 2));
                // this.overlaySticker.y = Math.ceil(
                //     Layout.scalePixels(
                //         -this.bounds.y -
                //             this.bounds.height / 2 +
                //             textureBounds.y +
                //             textureBounds.height / 2
                //     )
                // );
                // this.overlaySticker.textures = [
                //     this.assets.getSprite("overlay_" + overlayName),
                // ];
                // res();
                // this.overlaySticker.gotoAndStop(0);
            // }
    }

    showOverlay(
        id: number,
        animName?: string,
        loop: boolean = false,
        forceStatic: boolean = false
    ): Promise<boolean> {
        this.setId(id);
        return new Promise((res) => {
            if (!this.overlaySticker) {
                res();
            }
            let symSpriteId: number | string = this.config.symbolAssetsMap[
                this.id
            ].name;
            // animName = "_" + animName;
            // let animID = animName != "_anim" ? symSpriteId + animName : symSpriteId;
            const overlayData = this.config.overlayData[symSpriteId];
            if (!overlayData) {
                res();
            } else {
                let isAnim = overlayData.numFrames;
                let isText = overlayData.font;
                let overlayName = overlayData.name || symSpriteId;
                if (isAnim) {
                    animName = "_" + (animName || "anim");
                } else {
                    animName = "";
                }
                let textureBounds = Utils.deepClone(
                    this.positionDefinitions.get(
                        "overlay_" + overlayName + animName
                    )
                );
                if (!textureBounds) {
                    textureBounds = Utils.deepClone(
                        this.positionDefinitions.get("overlay")
                    );
                }
                this.overlaySticker.visible = true;
                // this.overlaySticker.addChild

                if (isAnim) {
                    this.overlaySticker.alpha = 1;
                    let animSuffix = animName != "_anim" ? animName + "_" : "_";
                    this.overlaySticker.textures = this.assets.generateFrames(
                        "overlay_" + overlayName + animSuffix,
                        3,
                        overlayData.numFrames
                    );
                    this.overlaySticker.animationSpeed = overlayData.fps
                        ? overlayData.fps / 60
                        : 1;
                        this.overlaySticker.loop = loop;
                    if (forceStatic) {
                        this.overlaySticker.gotoAndStop(0);
                        res();
                    } else {
                        this.overlaySticker.onLoop = this.overlaySticker.onComplete = () => {
                            res();
                        };

                        this.overlaySticker.play();
                    }
                } else {
                    this.overlaySticker.textures = [
                        this.assets.getSprite("overlay_" + overlayName),
                    ];
                    res();
                    this.overlaySticker.gotoAndStop(0);
                }

                if (textureBounds && !isText) {
                    Layout.testSetWidth(
                        this.overlaySticker,
                        textureBounds.width
                    );
                    let boundX = this.bounds.x + this.bounds.width / 2;
                    let textX = textureBounds.x + textureBounds.width / 2;

                    this.overlaySticker.x = Math.ceil(
                        Layout.scalePixels(textX - boundX)
                    );

                    // this.overlaySticker.x = Math.ceil(Layout.scalePixels(this.bounds.x + this.bounds.width / 2 - textureBounds.x - textureBounds.width / 2));
                    this.overlaySticker.y = Math.ceil(
                        Layout.scalePixels(
                            -this.bounds.y -
                                this.bounds.height / 2 +
                                textureBounds.y +
                                textureBounds.height / 2
                        )
                    );
                }
            }
        });
    }

    public removeOverlay(): Promise<boolean> {
        return new Promise((res) => {
            if (!this.overlaySticker) {
                res();
                return;
            }
            if(this.overlaySticker.children.length) {
                this.overlaySticker.removeChildren(0);
            }
            this.overlaySticker.stop();
            this.overlaySticker.visible = false;
            res();
        });
    }

    getId(): number {
        return this.id;
    }

    /**
     * Play symbol expand animation
     * @param id The ID of the symbol
     * @param animSuffix Overrides the default "expand" suffix (sym_expand)
     */
    public showExpand(id: number, animSuffix: string = ""): Promise<boolean> {
        if (!this.isLocked) {
            // Lock the animation so it doesn't get overlapped with regular win
            this.isLocked = true;

            // Then play the animation
            let animName = animSuffix != "" ? animSuffix : "expand";
            // debugger;
            return this.showAnim(id, animName);
        } else {
            return new Promise((res) => {
                res();
            });
        }
    }

    public showAnim(
        id: number,
        animName: string,
        loop = false,
        reverse = false,
        forcedFPS = -1,
        startFrame = 0
    ): Promise<boolean> {
        this.setId(id);
        return new Promise((res) => {
            let hasAnim = this.setupAnimation(
                loop,
                animName,
                reverse,
                forcedFPS
            );
            if (hasAnim) {
                TweenMax.killTweensOf(this.shineFilter.uniforms);
                // VisualUtil.tintTween(this.symbol, 0xffffff, .2);

                this.playAnimation(animName, startFrame).then(() => res(true));
                if (this.frame) {
                    TweenMax.to(this.frame, 0.1, { alpha: 1, overwrite: 1 });
                }
            } else {
                res(true);
            }
        });
    }

    public showWin(id: number, loop: boolean = false): Promise<boolean> {
        // VisualUtil.tintTween(this.symbol, 0xffffff, .2);
        if (!this.isLocked) {
            return this.showAnim(id, "anim", loop);
        } else {
            // debugger;
            return new Promise((res) => {
                res();
            });
        }
    }

    public showStatic(id: number): Promise<boolean> {
        return new Promise((res) => {
            this.setId(id);
            let hasAnim = this.setupAnimation(false, "anim");
            if (hasAnim) {
                this.symAnim.gotoAndStop(0);
                this.symAnim.visible = true;
            }
            res();
        });
    }

    getAnimDuration(id: number, animName: string): number {
        const symSpriteId: number | string = this.config.symbolAssetsMap[id]
            .name;
        animName = "_" + animName;
        let animID = animName != "_anim" ? symSpriteId + animName : symSpriteId;
        const animData = this.config.animData[animID];
        if (!animData) {
            return 0;
        }
        let fps = animData.fps || 60;
        return animData.numFrames / fps;
    }

    /**
     * Prepare the animation for execution
     */
    setupAnimation(
        loop: boolean = false,
        animName = "anim",
        reverse = false,
        forcedFPS = -1
    ): boolean {
        // Get the SYMBOL SpriteID
        const symSpriteId: number | string = this.config.symbolAssetsMap[
            this.id
        ].name;

        // To make setup easier - add the _anim underscore here
        if (animName.indexOf("_") != 0) {
            animName = "_" + animName;
        }
        this.symAnim.filters = [];

        // Build the animationID (used in game-config.json)
        // If it's the regular animation remove the "_anim" part as they are defined only with SpriteID
        //        Example: "a", "k", "q", etc.
        // If it's another animation add its name to the symbol SpriteID
        //        Example: "a_expand_0", "a_expand_loop"
        let animID = animName != "_anim" ? symSpriteId + animName : symSpriteId;

        // Retrieve the animation Data from game-config.json
        const animData = this.config.animData[animID];

        // Get the expected PSD layer name base (defaults to format: "sym_XXXXX_expand")
        // If "animName" is set in game-config - it will override the default symbol SpriteID layer name
        let animationIdentifier = "sym_" + symSpriteId + animName;

        if (animData && animData.animName) {
            animationIdentifier = animData.animName;
        }
        // Retrieve the ANIM PSD layer bounds based on the psdTextureID (warn if missing)
        let psdAnimBounds = Utils.deepClone(
            this.positionDefinitions.get(animationIdentifier)
        );

        // If not found - show a warning and use the SYMBOL bounds
        if (!psdAnimBounds) {
            if (animName != "_anim") {
                console.warn(
                    "[PSD] Missing bounds layer for animation: " +
                        animationIdentifier
                );
            }

            psdAnimBounds = Utils.deepClone(
                this.positionDefinitions.get("sym_" + symSpriteId)
            );
        }

        // Set the visibility if Fade or Frame animation type is present in AnimData
        // If no AnimData - should be still visible
        this.symAnim.visible = animData
            ? animData.numFrames || animData.fade
            : true;
        // Reset alpha to 1 (for Fade anim)
        this.symAnim.alpha = 1;
        // Set the loop as per the given parameter
        this.symAnim.loop = loop;

        // Build the animation textures
        // If it's the regular symbol animation - just take them from the already generated ones
        // If not - generate the frames
        let animTextures: PIXI.Texture[];
        if (animName == "_anim") {
            // Regular symbol animation
            animTextures = this.assets.getSymAnimTextures(this.id);
        } else if (animData?.numFrames) {
            // Custom animation - user either the name from the config, or the generated name without sym_
            // Default example - "XXXX_expand_000"
            animTextures = this.assets.generateFrames(
                (animData.animName ||
                    animationIdentifier.replace("sym_", "")) + "_",
                3,
                animData.numFrames
            );
        } 
        if(!animTextures) {
            let staticTexture  = this.assets.getTexture("sym_" + symSpriteId);
            animTextures = [staticTexture];
        }

        // Set animation object pivot point
        // Defaults to center, but can be overridden in game-config.json
        const animAnchor =
            this.config.symAnimAnchors[this.id] ||
            this.config.symAnimAnchors[animID];
        if (animAnchor) {
            this.symAnim.anchor.set(animAnchor.x, animAnchor.y);
        } else {
            this.symAnim.anchor.set(0.5, 0.5);
        }

        if (animTextures && reverse) {
            animTextures.reverse();
        }

        // Set textures, speed and filters based on animation Type
        if (animData && animData.numFrames) {
            this.symAnim.textures = animTextures;
            this.symAnim.animationSpeed = animData.fps ? animData.fps / 60 : 1;
        } else if (animData && animData.fade) {
            this.symAnim.textures = animTextures;
            this.symAnim.animationSpeed = animData.fps ? animData.fps / 60 : 1;
        } else if (animData && animData.shine) {
            this.symAnim.textures = animTextures;
            
            this.symAnim.filters = [this.shineFilter];
            this.shineFilter.uniforms.position = 0;
            this.shineFilter.uniforms.intensity = 0;
        }

        if (this.symAnim.animationSpeed && forcedFPS != -1) {
            this.symAnim.animationSpeed = forcedFPS / 60;
        }

        if (psdAnimBounds) {
            // If we have any bounds to work with - set the scale and position
            // Set the symbol animation view size based on the PSD ANIM bounds
            // Layout.testSetWidth(this.symAnim, psdAnimBounds.width);

            // let boundX = this.bounds.x + this.bounds.width / 2;
            // let textX = psdAnimBounds.x + psdAnimBounds.width / 2;
            // this.symAnim.x = Math.ceil(Layout.scalePixels(textX - boundX));

            // this.symAnim.y = Math.ceil(
            //     Layout.scalePixels(
            //         -this.bounds.y -
            //             this.bounds.height / 2 +
            //             psdAnimBounds.y +
            //             psdAnimBounds.height / 2
            //     )
            // );
            this.applyBound(psdAnimBounds);
        }

        return psdAnimBounds != null && animData != null;
    }

    protected applyBound(psdAnimBounds) {
        Layout.testSetWidth(this.symAnim, psdAnimBounds.width);

        let boundX = this.bounds.x + this.bounds.width / 2;
        let textX = psdAnimBounds.x + psdAnimBounds.width / 2;
        this.symAnim.x = Math.ceil(Layout.scalePixels(textX - boundX));

        this.symAnim.y = Math.ceil(
            Layout.scalePixels(
                -this.bounds.y -
                    this.bounds.height / 2 +
                    psdAnimBounds.y +
                    psdAnimBounds.height / 2
            )
        );
    }

    playHitAnimation(animData: any) {
        //TODO Remove and use other play animation method
        const animAnchor = animData.anchor;
        if (animAnchor) {
            this.symAnim.anchor.set(animAnchor.x, animAnchor.y);
        } else {
            this.symAnim.anchor.set(0.5, 0.5);
        }

        console.log("STATIC ,hit anim");
        this.symAnim.visible = true;
        this.symAnim.alpha = 1;
        this.symAnim.loop = false;

        const frameData = animData.frames;
        const fadeData = animData.fade;
        if (frameData) {
            this.symAnim.textures = this.assets.generateFrames(
                frameData.prefix,
                frameData.pad,
                frameData.end
            );
            this.symAnim.animationSpeed = animData.fps ? animData.fps / 60 : 1;
            this.symAnim.onComplete = this.symAnim.onLoop = this.hideSymAnim.bind(
                this
            );
            this.symAnim.gotoAndPlay(0);
        } else if (fadeData) {
            const duration = fadeData.duration ? fadeData.duration : 0.1;
            this.symAnim.textures = [
                this.assets.getTexture(fadeData.textureName),
            ];
            TweenMax.from(this.symAnim, duration, {
                alpha: 0,
                yoyo: true,
                repeat: 1,
            });
        }
    }

    hideSymAnim(removeOverlay = true) {
        this.symAnim.visible = false;
        this.symAnim.alpha = 0;
        this.symAnim.loop = false;
        this.symAnim.filters = [];
        if (this.overlaySticker && removeOverlay) {
            // this.overlaySticker.visible = false;
            this.overlaySticker.alpha = 0;
        }
    }

    public replayAnimation(fromFrame: number) {
        return new Promise<boolean>((resolve) => {
            this.symAnim.onComplete = () => resolve(true);
            this.symAnim.gotoAndPlay(fromFrame || 0);
        });
    }

    protected playAnimation(
        animName: string,
        startFrame: number
    ): Promise<boolean> {
        return new Promise((res) => {
            let symSpriteId: number | string = this.config.symbolAssetsMap[
                this.id
            ].name;
            animName = "_" + animName;
            if (animName && animName != "_anim") {
                symSpriteId = symSpriteId + animName;
            }
            const animData = this.config.animData[symSpriteId];
            let resComplete = () => {
                res(true);
            };

            this.currentAnimation = animName;

            if (animData.numFrames) {
                this.symAnim.visible = true;
                this.symAnim.gotoAndPlay(startFrame);
                this.symAnim.onComplete = this.symAnim.onLoop = resComplete;
            } else if (animData.fade) {
                this.symAnim.visible = true;
                TweenMax.from(
                    this.symAnim,
                    this.config.showWinLineDuration2 * 0.5,
                    {
                        alpha: 0,
                        yoyo: true,
                        repeat: animData.loop ? -1 : 1,
                        onComplete: resComplete,
                    }
                );
            } else if (animData.shine) {
                this.symAnim.visible = true;
                this.symAnim.gotoAndPlay(0);
                TweenMax.to(this.shineFilter.uniforms, 1.5, {
                    position: 1/this.symAnim.scale.x,
                    yoyo: false,
                    repeat: animData.loop ? -1 : 0,
                    onComplete:resComplete,
                    onRepeat:resComplete
            
                });
                TweenMax.to(this.shineFilter.uniforms, 0.2, {
                    intensity: 2,
                    // onComplete: resComplete,
                });
                if (!animData.loop) {
                    TweenMax.to(this.shineFilter.uniforms, 0.2, {
                        intensity: 0,
                        delay: 6,
                        // onComplete: resComplete,
                    });
                }
                // res(true);
            } else {
                res(true);
            }
        });
    }

    // fade()
    // {
    //     this.symAnim.visible = false;
    //     this.symbol.visible = true;
    //     this.symbol.filters = [];
    //     VisualUtil.tintTween(this.symbol, this.config.symbolTintColor, .2);
    // }

    stopAnimation() {
        this.symAnim.stop();
        this.symAnim.loop = false;
        this.symAnim.filters = [];

        this.currentAnimation = "";

        this.currentAnimation = "";

        // this.symbol.visible = true;
        this.symAnim.visible = false;

        TweenMax.killTweensOf(this.shineFilter.uniforms);
        TweenMax.killTweensOf(this.symAnim);

        const hideTime = 0.2;

        // if (this.symbol.filters.indexOf(this.shineFilter) !== -1)
        // {
        //     TweenMax.to(this.shineFilter.uniforms, hideTime,
        //         {intensity: 0, onComplete: this.removeFilters, onCompleteScope: this});
        // }
    }

    isOn(): boolean {
        return this.symAnim.visible;
    }
    
    getAnimBounds() {
        return {
            x: this.symAnim.x,
            y: this.symAnim.y,
            width: this.symAnim.width,
            height: this.symAnim.height,
        };
    }

    hideWin() {
        // VisualUtil.tintTween(this.symbol, 0xffffff, .2);
        if (!this.isLocked) {
            this.stopAnimation();
        }

        if (this.frame) {
            TweenMax.to(this.frame, 0.1, { alpha: 0 });
        }
    }

    removeFilters() {
        this.symAnim.filters = [];
    }

    getReelIdx() {
        return this.reelIdx;
    }
}

// export default ReelSymbol
